import firebase from "firebase/app";
import "firebase/auth";
import router from "@/router";
import state from "./state.js";
import Axios from "axios";

const actions = {
  // ////////////////////////////////////////////
  // SIDEBAR & UI UX
  // ////////////////////////////////////////////

  updateSidebarWidth({ commit }, width) {
    commit("UPDATE_SIDEBAR_WIDTH", width);
  },
  updateI18nLocale({ commit }, locale) {
    commit("UPDATE_I18N_LOCALE", locale);
  },
  toggleContentOverlay({ commit }) {
    commit("TOGGLE_CONTENT_OVERLAY");
  },
  updateTheme({ commit }, val) {
    commit("UPDATE_THEME", val);
  },
  updateUserRole({ commit }, val) {
    commit("UPDATE_USER_ROLE", val);
  },

  // ////////////////////////////////////////////
  // COMPONENT
  // ////////////////////////////////////////////

  // VxAutoSuggest
  updateStarredPage({ commit }, payload) {
    commit("UPDATE_STARRED_PAGE", payload);
  },

  //  The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit("ARRANGE_STARRED_PAGES_LIMITED", list);
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit("ARRANGE_STARRED_PAGES_MORE", list);
  },
  //Authentication and user data//
  login({ commit, dispatch, state }, payload) {
    firebase
      .auth()
      .signInWithEmailAndPassword(
        payload.userDetails.email,
        payload.userDetails.password
      )
      .then(
        (result) => {
          router.push(router.currentRoute.query.to || "/");
          dispatch("getUserData", payload);
        },
        (err) => {
          payload.notify({
            time: 2500,
            title: "Error",
            text: err.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        }
      );
  },
  getUserData({ commit, dispatch }, payload) {
    Axios.get(
      state.endpoint2 + "/getuserdetails?email=" + payload.userDetails.email
    )
      .then((response) => {
        console.log(response.data);
        var data = response.data;
        var itemId = data._id;
        var itemObj = {
          id: itemId,
          userName: data.userName,
          email: data.email,
          phoneNumber: data.phoneNumber
        };
        var newPayload = {
          clientId: itemId,
          notify: payload.notify
        };
        commit("UPDATE_AUTHENTICATED_USER", itemObj);
        dispatch("getZoneData", newPayload);
        dispatch("getLocationData", newPayload);
        dispatch("getModemData", newPayload);
      })
      .catch(function(error) {
        payload.notify({
          title: "Error",
          text: error.response.data,
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle"
        });
      });
  },
  getZoneData({ commit }, payload) {
    Axios.get(state.endpoint2 + "/zones?clientId=" + payload.clientId)
      .then((response) => {
        var zoneList = [];
        var document = response.data;
        for (var m in document) {
          var itemId = document[m]._id;
          var itemObj = {
            id: itemId,
            clientId: document[m].clientId,
            name: document[m].name,
            address: document[m].address,
            coordinates: document[m].coordinates,
            insideState: document[m].insideState,
            district: document[m].district
          };
          zoneList.push(itemObj);
        }
        commit("UPDATE_ZONES", zoneList);
      })
      .catch(function(error) {
        payload.notify({
          title: "Error",
          text: error.response.data,
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle"
        });
      });
  },
  getLocationData({ commit }, payload) {
    Axios.get(state.endpoint2 + "/locations?clientId=" + payload.clientId)
      .then((response) => {
        var locationList = [];
        var document = response.data;

        for (var n in document) {
          var itemId = document[n]._id;
          var itemObj = {
            id: itemId,
            clientId: document[n].clientId,
            name: document[n].name,
            address: document[n].address,
            coordinates: document[n].coordinates,
            locationZone: document[n].locationZone
          };
          locationList.push(itemObj);
        }
        commit("UPDATE_LOCATIONS", locationList);
      })
      .catch(function(error) {
        payload.notify({
          title: "Error",
          text: error.response.data,
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle"
        });
      });
  },
  getModemData({ commit }, payload) {
    Axios.get(state.endpoint2 + "/modems?clientId=" + payload.clientId)
      .then((response) => {
        var modemList = [];
        var document = response.data;

        for (var x in document) {
          var itemId = document[x]._id;

          var itemObj = {
            id: itemId,
            clientId: document[x].clientId,
            name: document[x].name,
            address: document[x].address,
            coordinates: document[x].coordinates,
            insideLocation: document[x].insideLocation,
            coverageRadius: document[x].coverageRadius,
            modemId: document[x].modemId
          };
          modemList.push(itemObj);
        }
        commit("UPDATE_MODEMS", modemList);
      })
      .catch(function(error) {
        payload.notify({
          title: "Error",
          text: error,
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle"
        });
      });
  },
  updateAuthenticatedUser({ commit }, payload) {
    commit("UPDATE_AUTHENTICATED_USER", payload);
  }
};

export default actions;
